'use client'

import type { CourseDetail } from "@/lib/types/course/detail"
import type { ILesson } from "@/lib/types/course/lesson"
import CourseActions from "./CourseActions"

interface FloatProps {
	course: CourseDetail
}

const Float = ({ course }: FloatProps) => {

	return (
		<div className="flex flex-col items-center justify-between p-2">
			<div className="flex-1">
				<div className="font-bold text-gray-900">{course.name}</div>
			</div>
			<CourseActions course={course} className="w-full px-2 py-1" showTimer={false} />
		</div>
	)
}

export default Float
